import { useRef } from "react";

/*
	Un botón que manda algo al servidor corre UNA vez a la vez. En el teléfono, dos o tres toques seguidos llegan antes de que React
	vuelva a pintar el botón desactivado (setBusy no es inmediato) y el guardado salía varias veces: 3 toques en «Guardar y
	Matricular» = 6 PUT y 6 envíos (prueba de Esteban, 2026-10-09). El candado es una ref: se cierra en el mismo toque.
	esperar(): para lo que NO debe saltarse sino ir después (abrir otra solicitud tras guardar esta): espera al envío en curso.
*/
export type UnaALaVez = (<T>(fn: () => Promise<T>) => Promise<T | undefined>) & { esperar: () => Promise<void> };

export const useUnaALaVez = (): UnaALaVez => {
	const enCurso = useRef<Promise<any> | null>(null);
	const correr = (<T>(fn: () => Promise<T>): Promise<T | undefined> => {
		if (enCurso.current) return Promise.resolve(undefined);
		const p = (async () => {
			try {
				return await fn();
			} finally {
				enCurso.current = null;
			}
		})();
		enCurso.current = p;
		return p;
	}) as UnaALaVez;
	correr.esperar = () => (enCurso.current ? enCurso.current.then(() => undefined, () => undefined) : Promise.resolve());
	return correr;
};

export default useUnaALaVez;
